<template>
  <header :class="['c-header',type]">
    <div class="header-w">
      <c-icon :name="icon" class="icon" @click="$emit('click')" v-if="icon"></c-icon>
    <div class="c-header-content">
      <slot></slot>
    </div>
    <div class="c-header-right" @click="$emit('rightClick')" v-if="right">寄售订单</div>
    </div>
  </header>
</template>

<script>
  import CIcon from "@/components/icon/index";

  export default {
    name: 'CHeader',
    components: {CIcon},
    props: {
      icon: {
        type: String,
        default: 'left'
      },
      right: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'primary',
        validate(value) {
          return ['primary', 'gray'].includes(value)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "var";
  .c-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9;
    @include x-padding-top;
   .header-w {
    position: relative;
   }
    &.primary {
      line-height: .88rem;
      background: $active-color;
      background: #ffffff;
      color: #333333;
    }
    &.gray{
      line-height: 1rem;
      color: $color;
      background: $white;
      box-shadow: 0 .04rem .12rem $button-border-color;
    }
    .icon {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      line-height: .9rem;
      width: .6rem;
      font-size: .4rem;
    }
    &-content {
      font-size: .32rem;
      text-align: center;
    }
    &-right {
      position: absolute;
      right: .2rem;
      top: 50%;
      transform: translateY(-50%);
      font-size: .28rem;
      color: #000000;
    }
  }
</style>
